import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchAgroExporterProcesses(agro_exporter_id) {
    return RequesterV1.get(
      `packing_house/quality_control/process/list_processes/${agro_exporter_id}`
    );
  },
};
